module.exports = __webpack_public_path__ + "assets-cabinet/img/profile.91a6e07d.svg";